<template>
  <div class="completeStock">
    <div class="title">
      <p>主订单号：{{orderNo}}({{orderstatus}})</p>
      <!-- <p class="info blue">按单品打包</p> -->
      <div class="oper-btns">
        <el-button
          type="primary"
          size="small"
          @click="autoStock"
          v-show="orderstatus==='备货中'"
          v-if="!isFactory"
        >自动拣货</el-button>
        <el-button
          type="primary"
          size="small"
          @click="printList"
        >导出货物清单</el-button>
      </div>
    </div>
    <el-form
      label-position="right"
      :rules="packageRule"
      status-icon
      :model="orderForm"
      ref="orderForm"
    >
      <el-table
        :data="orderForm.orderTableData"
        border
        style="width: 100%"
      >
        <el-table-column
          label="No"
          type="index"
          width="40"
        >
        </el-table-column>
        <el-table-column
          prop="order_number"
          label="子订单"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="ruigu_code"
          label="锐锢编码"
        >
        </el-table-column>
        <el-table-column
          prop="self_code"
          label="三方编码"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
          width="320"
        >
        </el-table-column>
        <el-table-column
          prop="unit"
          label="单位"
        >
        </el-table-column>
        <el-table-column
          prop="amount"
          label="订购数量"
        >
        </el-table-column>
        <el-table-column
          prop="send_amount"
          label="实发数量"
        >
        <!-- 备货中才能填实发数量 -->
          <template slot-scope="scope">
            <el-form-item
              v-if="orderstatus==='备货中'&&!(scope.row.status==='-1'||scope.row.status==='-2'||scope.row.status==='-3')"
              :prop="'orderTableData.' + scope.$index + '.send_amount'"
              :rules="scope.row.status!=='-1'&&scope.row.status!=='-2'&&scope.row.status!=='-3'?packageRule.send_amount:[]"
            >
              <el-input
                v-model="scope.row.send_amount"
                v-if="orderstatus==='备货中'&&!(scope.row.status==='-1'||scope.row.status==='-2'||scope.row.status==='-3')"
              ></el-input>
            </el-form-item>
              <span v-show="orderstatus!=='备货中'">{{scope.row.send_amount}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="product_name" label="单位">
        </el-table-column> -->
        <!-- <el-table-column
          prop="amount"
          label="包裹数"
          width="100"
        >
          <template slot-scope="scope">
            <el-form-item :prop="'orderTableData.' + scope.$index + '.box_num'">
              <el-input v-model="scope.row.box_num"></el-input>
            </el-form-item>
          </template>
        </el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          prop="od_statusName"
          label="状态"
        >
        </el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          prop="box_codes"
          label="备注"
          width="280"
        >
        </el-table-column> -->
      </el-table>
    </el-form>
    <div class="package" v-if="!isFactory">
      <div class="weightTable">
        <p class="subtable blue">按主订单</p>
        <el-form
          label-position="right"
          :rules="weightRule"
          status-icon
          :model="weightForm"
          ref="weightForm"
        >
          <el-table
            :data="weightData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="weight"
              label="总重量(kg)"
            >
              <template slot-scope="scope">
                <el-form-item prop="weight">
                  <el-input v-model="weightForm.weight"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="box_num"
              label="打包数"
            >
              <template slot-scope="scope">
                <el-form-item prop="box_num">
                  <el-input v-model="weightForm.box_num"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="box_codes"
              label="箱码"
              width="535"
            >
              <template slot-scope="scope">
                <el-form-item prop="weight">
                  <span
                    v-show="showBox"
                    class="box_codes"
                    v-for="item in weightForm.box_codes"
                    :key="item.id"
                    :index="item.box_code"
                    :class="{ active: item.active===true }"
                    @click="getBoxData(item)"
                  >{{item.box_code}}
                    <i
                      @click="deleteBox(item.id)"
                      class="el-icon-circle-close"
                    ></i>
                  </span>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <!-- <div class="packageTable">
        <p class="subtable blue">按主订单合并打包</p>
        <el-form label-position="right" :rules="packageRule" status-icon :model="packageForm" ref="packageForm">
          <el-table :data="packageData" stripe border style="width: 100%">
            <el-table-column prop="ruigu_code" label="包裹数" width="100">
              <template slot-scope="scope">
                <el-form-item prop="box_num">
                  <el-input v-model="packageForm.box_num"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="ruigu_code" label="备注"></el-table-column>
          </el-table>
        </el-form>
        <p>说明：两种打包方式任选其一，不可同时填写。</p>
      </div> -->
    </div>
    <div class="bottom" v-if="!isFactory">
      <p >生成箱码总数：{{total_box_num}}</p>
      <el-button
        type="primary"
        size="small"
        @click="completeStock"
        v-show="orderstatus==='备货中'"
      >备货完成</el-button>
      <el-button
        type="primary"
        size="small"
        @click="save"
        :disabled="saveLoading"
        :loading="saveLoading"
        v-show="orderstatus!=='备货中'"
      >保存</el-button>
      <el-button
        type="primary"
        size="small"
        @click="print"
      >打印全部箱码</el-button>
      <el-button
        type="primary"
        size="small"
        @click="printOneBox"
      >补打箱码</el-button>
      <el-button
        type="primary"
        size="small"
        @click="clearBox"
      >清除全部箱码</el-button>
      <el-button
        type="primary"
        size="small"
        style="float:right;"
        v-show="showLogisticsSheet"
        @click="printLogisticsSheet"
      >通知物流取货</el-button>
    </div>
    <boxcode ref="refboxcode" v-show="false"></boxcode>
  </div>
</template>
<script>
import { getOdStatusList } from '@/utils/utils'
import { updatePack, pareDone, getOrder, listBox, printLogisticsSheet, printOneBox, batchPrintBoxCode } from '@/models/orderModel'
import { getPrintData, print } from '@/models/commonModel'
import boxcode from '@/components/print/boxcode'
export default {
  name: 'completeStock',
  components: {boxcode},
  data () {
    var amountValid = (rule, value, callback) => {
      let index = rule.field.split('.')[1]
      if (value !== this.orderForm.orderTableData[index].amount) {
        this.$message.error('实发数量与订购数量不一致')
        callback(new Error())
      } else {
        callback()
      }
    }
    return {
      isZhifaOrFactory: localStorage.getItem('shop_type') === '2' || localStorage.getItem('shop_type') === '1',
      isFactory: false,
      orderNo: '',
      orderstatus: '',
      total_box_num: '',
      packageData: [1],
      weightData: [1],
      orderForm: {
        orderTableData: []
      },
      weightForm: {
        weight: '',
        box_num: '',
        box_codes: []
      },
      boxCodeNum: '',
      weightRule: {
        // weight: [{ required: true, trigger: 'blur' }],
        // box_num: [{ required: true, trigger: 'blur' }]
      },
      packageRule: {
        send_amount: [
          { validator: amountValid, required: true, trigger: 'blur' }
        ]
      },
      del_id: '',
      showBox: true,
      selectBoxIds: [],
      saveLoading:false,
      showLogisticsSheet: localStorage.getItem('shop_type') === '1' || localStorage.getItem('shop_type') === '2'
    }
  },
  watch: {
    orderstatus (val) {
      if (val === '备货完成') {
        this.getlistBox()
      }
    }
  },
  mounted () {
    if (localStorage.getItem('shop_type') === '2') {
      this.isFactory = true
    }
    this.getOrderData()
    this.getlistBox()
  },
  methods: {
    async printOneBox () {
      this.selectBoxIds = []
      let box = []
      for (let i of this.weightForm.box_codes) {
        if (i.active === true) {
          this.selectBoxIds.push(i.id)
        }
      }
      for (let i of this.selectBoxIds) {
        let params = {
          id: i
        }
        let data = await printOneBox(params)
        console.log(data, 'printOneBox data')
        data.data.forEach(item => {
          box.push(item)
        })
      }
      if (box.length > 0) {
        this.$refs.refboxcode.myPrint(box)
      }
    },
    getBoxData (item) {
      this.showBox = false
      this.$nextTick(() => {
        this.$set(item, 'active', !item.active)
        this.showBox = true
      })
    },
    async printLogisticsSheet () {
      let params = {
        ids: this.$route.query.id
      }
      let res = await printLogisticsSheet(params)
      if (res.code === 200) {
        let data = res.data
        if (data.length === 0) {
          this.$message.success('通知成功')
          this.getOrderData()
          this.getlistBox()
        } else {
          this.$message.error(data[0].msg)
        }
      } else {
        this.$message.error(res.message)
      }
    },
    deleteBox (id) {
      for (let i = 0; i < this.weightForm.box_codes.length; i++) {
        if (this.weightForm.box_codes[i].id === id) {
          this.weightForm.box_codes.splice(i, 1)
        }
      }
      if (this.del_id === '') {
        this.del_id = this.del_id + id
      } else {
        this.del_id = this.del_id + ',' + id
      }
    },
    async save () {
      let params = {
        box_num: this.weightForm.box_num,
        weight: this.weightForm.weight,
        id: this.$route.query.id
      }
      if (this.del_id !== '') {
        params.del_id = this.del_id
      }
      let data = await updatePack(params)
      if (data.message === 'Success') {
        this.saveLoading = true
        this.$message.success('保存成功')
        this.del_id = ''
        setTimeout(() => {
          this.saveLoading = false
        }, 1000 * 7);
      }
      this.getlistBox()
      this.getOrderData()
    },
    async getlistBox () {
      let params = { id: this.$route.query.id }
      let data = await listBox(params)
      this.weightForm.box_codes = data
      for (let i of data) {
        i.active = false
      }
    },
    async print (id) {
      // let params = {
      //   id: this.$route.query.id
      // }
      // let data = await getPrintData(params)
      // this.$refs.refboxcode.myPrint(data)
      // 2021-11-25 接口换成 和三方备货出库单列表页的 打印全部箱码 同一个
      let params = {
        ids: JSON.stringify([this.$route.query.id])
      }
      let res = await batchPrintBoxCode(params)
      // console.log(res);
      if (res.code === 200) {
        let success = res.data.succeed;
        let failedData = res.data.failed;
        if (failedData.length > 0) {
          this.$message.warning(failedData[0].msg)
          // failedData.forEach((item) => {
          //   item.main_number = boxcodeList.find((order) => {
          //     return order.id === item.id;
          //   }).main_number;
          // });
          // let html = "";
          // failedData.forEach((item) => {
          //   html +=
          //     '<p style="padding:5px;">主订单号：' +
          //     item.main_number +
          //     "," +
          //     item.msg +
          //     "</p>";
          // });
          // this.$message({
          //   showClose: true,
          //   type: "error",
          //   iconClass: "11",
          //   dangerouslyUseHTMLString: true,
          //   message: html,
          //   duration: 0,
          // });
        } else {
          let printData = [];
          for (const key in success) {
            if (success.hasOwnProperty(key)) {
              let item = success[key];
              for (let i of item) {
                i.code = i.serial_number;
                i.print_interval = 5;

                printData.push(i);
              }
            }
          }
          this.$refs.refboxcode.myPrint(printData);
        }
      }
      // for (let i of data) {
      //   // i.print_model = 'HM-A300'
      //   // i.line_code = ''
      //   // i.prefix = ''
      //   // i.user_name = i.recipient
      //   // i.print_type = 'ApBoxInfoModelBt1' // 蓝牙
      //   // i.print_type = 'ApBoxInfoModel'
      //   // delete i.recipient
      //   // delete i.is_last
      //   // delete i.num
      //   if (!this.isZhifaOrFactory) {
      //     delete i['courier_number']
      //   }
      //   i.code = i.serial_number
      //   console.log(i, '打印箱码')
      //   let printData = await print(i)
      //   if (printData === false) {
      //     return false
      //   }
      // }
      // let data = {
      //   'file_name': '1发货标签81612221333023717',
      //   'print_type': 'ApBoxInfoModelBt1',
      //   'box_num': 'RBAP45591811270001-7-7',
      //   'sm_num': 'SM2018010100011',
      //   'print_model': 'HM-A300',
      //   'mobile': '12345678911',
      //   'prefix': '上海市市辖区杨浦区',
      //   'line_code': '线路：上海001',
      //   'user_name': '姓名：收货人',
      //   'address': '上海市杨浦区国伟路35号上海市杨浦区国伟路35号'
      // }
      // await print(data)
    },
    async getOrderData () {
      let params = {
        id: this.$route.query.id
      }
      let data = await getOrder(params)
      // if (data.box_codes) {
      //   this.boxCodeNum = data.box_codes.split(',').length
      // }
      this.orderNo = data[0].main_number
      this.weightForm.weight = data[0].weight
      this.weightForm.box_num = data[0].box_num
      this.orderstatus = getOdStatusList().mo_statusList.filter(
        item => item.value === data[0].mo_status
      )[0].label
      for (let i of data) {
        i.od_statusName = getOdStatusList().statusList.filter(
          item => item.value === i.status
        )[0].label
      }
      this.orderForm.orderTableData = data
      this.autoStock()
      this.total_box_num = this.orderForm.orderTableData[0].box_num
    },
    completeStock () {
      this.$refs['orderForm'].validate(orderValid => {
        if (orderValid) {
          this.$refs['weightForm'].validate(async weightValid => {
            if (weightValid) {
              let sendAmounts = []
              for (let i of this.orderForm.orderTableData) {
                sendAmounts.push(i.send_amount)
              }
              let pareDoneParams = {
                id: this.$route.query.id,
                send_amounts: JSON.stringify(sendAmounts),
                weight: this.weightForm.weight,
                box_num: this.weightForm.box_num
              }
              let pareDoneData = await pareDone(pareDoneParams)
              this.save()
              if (pareDoneData.message === 'Success') {
                this.$message.success('备货完成成功')
                this.getOrderData()
              }
            } else {
              this.$message.error('请输入总重量')
            }
          })
        }
      })
    },
    autoStock () {
      this.orderForm.orderTableData.forEach(element => {
        element.send_amount = element.amount
      })
    },
    printList () {
      this.$router.push('/order/deliverySheet?id=' + this.$route.query.id)
    },
    clearBox () {
      this.weightForm.box_num = 0
      let arr = []
      console.log(this.weightForm.box_codes, '箱码')
      this.weightForm.box_codes.forEach((item) => {
        if (item.hasOwnProperty('id')) {
          // this.deleteBox(item.id)
          arr.push(item.id)
        }
      })
      // this.del_id += arr.join(',')
      this.del_id = this.del_id + ',' + arr.join(',')
      console.log(this.del_id, '箱码')
      this.weightForm.box_codes = []
    }
  }
}
</script>
<style lang="scss">
.completeStock {
  padding: 0px 0px 0px 10px;
  .el-form .el-form-item {
    margin-bottom: 0px;
  }
  .el-input {
    width: 70px !important;
  }
  .blue {
    color: rgb(94, 131, 225);
    font-weight: bold;
    font-size: 16px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    p {
      font-size: 16px;
    }
    .info {
      margin-right: 60px;
    }
  }
  .package {
    // text-align: center;
    margin-top: 100px;
    // display: flex;
    // justify-content: center;
    .weightTable {
      // width: 200px !important;
      // margin-right: 100px;
      .cell {
        height: auto !important;
      }
      td {
        .el-form-item__content {
          line-height: 20px;
        }
        .cell {
          height: 48px;
        }
        .el-input__inner {
          height: 30px;
          margin: 5px;
        }
      }
    }
    .orderTable {
      width: 400px !important;
      td {
        .el-form-item__content {
          line-height: 44px;
        }
        .cell {
          height: 48px;
        }
        .el-input__inner {
          height: 30px;
        }
      }
    }
  }
  .bottom {
    width: 100%;
    text-align: center;
    // margin-left: px;
    bottom: 40px;
  }
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    padding: 0;
  }
  .el-table_2_column_12 {
    text-align: left;
    padding: 0px 0px 0px 4px;
  }
  .box_codes {
    border: 1px solid rgb(249, 244, 225);
    background-color: rgb(249, 244, 225);
    margin-right: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  .box_codes.active {
    background-color: #ff6224;
    border-color:#ff6224;
    color:#fff;
  }
  .box_codes {
    i:hover {
      color: red;
      cursor: pointer;
    }
  }
  .oper-btns {
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/completeStock.vue